/*
 * @Editor: SiYuan Wang
 * @Date: 2018-08-22 15:36:33
 * @Description: filter
 */

Vue.filter('tofloat', function (value, num) {
    if (value === 0) {
        if (num === 2) {
            return '0.00';
        }
        if (num === 4) {
            return '0.0000';
        }
    }
    if (typeof value === 'undefined'
        || value === null
        || value === ''
        || isNaN(Number(value))) {
        return '';
    }
    value = value.toString();
    if(value.lastIndexOf('.') === -1){
        value = parseFloat(value).toFixed(num);
    }
    var str = value.substring(0, value.lastIndexOf('.') + (num + 1));
    return parseFloat(str).toFixed(num);
});

Vue.filter('intToChinese', function (value) {
    if (Number(value) === 0) return '零';
    var unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分",
        str = "";
    value = Number(value) + "00";
    var p = value.indexOf('.');
    if (p >= 0) value = value.substring(0, p) + value.substr(p+1, 2);
    unit = unit.substr(unit.length - value.length);
    for (var i = 0; i < value.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(~~value.charAt(i)) + unit.charAt(i);
    }
    return str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(兆|万|亿|元)/g, "$1")
        .replace(/(兆|亿)万/g, "$1")
        .replace(/(京|兆)亿/g, "$1")
        .replace(/(京)兆/g, "$1")
        .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟")
        .replace(/^元零?|零分/g, "")
        .replace(/(元|角)$/g, "$1整");
});

Vue.filter('intToChinesePortion', function (value) {
    if (Number(value) === 0) return '零';

    var unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾 ",
        _value = Number(value).toString(),
        integerStr = '',
        decimalStr = '',
        integerValue = null,
        decimalValue = null;
    var p = _value.indexOf('.');
    if (p >= 0) {
        integerValue = _value.substring(0, p);
        decimalValue = _value.substr(p+1, 2);
    } else {
        integerValue = _value;
    }
    unit = unit.substr(unit.length - integerValue.length);
    for (var i = 0; i < integerValue.length; i++) {
        if(integerValue == '0'){
            integerStr = '零'
        }else {
            integerStr += '零壹贰叁肆伍陆柒捌玖'.charAt(~~integerValue.charAt(i)) + unit.charAt(i);
        }
    }
    if (decimalValue !== null) {
        decimalStr += '点';
        for (var i = 0; i < decimalValue.length; i++) {
            decimalStr += '零壹贰叁肆伍陆柒捌玖'.charAt(~~decimalValue.charAt(i));
        }
    }

    return integerStr
        .replace(/零(仟|佰|拾)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(兆|万|亿)/g, "$1")
        .replace(/(兆|亿)万/g, "$1")
        .replace(/(京|兆)亿/g, "$1")
        .replace(/(京)兆/g, "$1")
        .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟")
        .replace(/(零)* $/g, "")
        .replace(/ $/g, "") + decimalStr;
});

Vue.filter('formatDate', function (input) {
    if (input) {
        var d = new Date(input);
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        return year+ '-' + month + '-' + day;
    }

    return '--';
});

Vue.filter('toWan', function (value) {
    if (value) {
        var wan = parseFloat(value) / 10000;
        // if (wan >= 1.00) {
        if(wan%1 === 0){
            return parseInt(wan) + '万'
        }
        return wan + '万';
        // }
        // return value;
    }
    return '0';
});

Vue.filter('hideMobile', function (value) {
    if (value) {
        return value.substring(0, 3) + '****' + value.substring(7, 11);
    }
    return '';
});

Vue.filter('formatFullDate', function (input) {
    if(!isNaN(Number(input))){
        var d = new Date(input);
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        var hour = d.getHours() <10 ? '0' + d.getHours() : '' + d.getHours();
        var minutes = d.getMinutes() <10 ? '0' + d.getMinutes() : '' + d.getMinutes();
        var seconds = d.getSeconds() <10 ? '0' + d.getSeconds() : '' + d.getSeconds();
        return year+ '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
    }
    return input
    
})



// WEBPACK FOOTER //
// ./src/js/filter.js